import ChilebusAboutus from '../ThemeFour/Chilebus/ChilebusAboutus';
import React from 'react';
import TepualAboutUs from '../theme5/TepualPages/TepualAboutUs';
import ThemeFiveAboutUsScreen from '../theme5/ThemeFivePages/ThemeFiveAboutUsScreen';
import ThemeFourAboutUsScreen from '../ThemeFour/ThemeFourPages/ThemeFourAboutUsScreen';
import ThemeSevenAboutUsScreen from '../ThemeSeven/ThemeSevenPages/ThemeSevenAboutUsScreen';
import ThemeTenAboutUs from '../ThemeTen/ThemeTenPages/ThemeTenAboutUs';
import ThemeTenFleet from '../ThemeTen/ThemeTenPages/ThemeTenFleet';
import ThemeThreeAboutUsScreen from '../ThemeThree/ThemeThreePages/ThemeThreeAboutUsScreen';
import { connect } from 'react-redux';

const CommonAboutUsPage = props => {
	const getPage = () => {
		const themeType = props.home && props.home.operator && props.home.operator.theme_type;
		const opname = props.home && props.home.operator && props.home.operator.operator_name;

		// Sajad used TepualAboutUs page in  andimar in get routes so i copied same
		if (themeType === 1) {
			return <TepualAboutUs />;
		} else if (themeType === 5) {
			return <ThemeFiveAboutUsScreen />;
		} else if (themeType === 4) {
			return <ThemeFourAboutUsScreen />;
		} else if (themeType === 3) {
			return <ThemeThreeAboutUsScreen />;
		} else if (themeType === 7) {
			return <ThemeSevenAboutUsScreen />;
		} else if (opname === 'traveltur') {
			return <ThemeTenAboutUs />;
		}

	};

	return <div>{getPage()}</div>;
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
// function mapDispatchToProps(dispatch) {
//   return {
//     actions: bindActionCreators({ ...actions }, dispatch),
//   };
// }

export default connect(mapStateToProps, {})(CommonAboutUsPage);



// WEBPACK FOOTER //
// ./src/features/themes/common-pages/CommonAboutUsPage.js